import { render, staticRenderFns } from "./ManterPraticasLinguagemView.vue?vue&type=template&id=5ed10e72"
import script from "./ManterPraticasLinguagemView.vue?vue&type=script&lang=js"
export * from "./ManterPraticasLinguagemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports